

import { Component, Vue, Prop } from "vue-property-decorator"

import TextAreaExpand from "../Fields/TextAreaExpand.vue"
import DataSourceSelect from "../Fields/DataSourceSelect.vue"
import DataSourceTemplate from "../Fields/DataSourceTemplate.vue"
import DateTime from "../Fields/DateTime.vue"
import Tags from "../Fields/Tags.vue"
import Numeric from "../Fields/Numeric.vue"
import UserRole from "./Users/UserRole.vue"
import ExternalLink from "../Fields/ExternalLink.vue"
import UniqueCaseNumber from "../Fields/CaseNumber.vue"
import UserImage from "@/components/UserImage.vue"

import CaseFileUpload from "./Files/CaseFileUpload.vue"
import CaseFileDisplay from "./Files/CaseFileDisplay.vue"
import MapLocation from "@/components/Fields/MapLocation.vue"

import { FieldDisplay } from "@/types/mergeFieldTypes"

@Component({
	components: {
		"text-area-expand": TextAreaExpand,
		"file-upload": CaseFileUpload,
		"case-file": CaseFileDisplay,
		"data-select": DataSourceSelect,
		"data-template": DataSourceTemplate,
		"tags": Tags,
		"numeric": Numeric,
		"date-time": DateTime,
		"map-location": MapLocation,
		"user-role": UserRole,
		"external-link": ExternalLink,
		"case-number": UniqueCaseNumber,
		"user-image": UserImage
	}
})
export default class MergeField extends Vue {
	@Prop(Object)
	field!: FieldDisplay;
}
